import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "../css/PageLoader.css";

const PageLoader = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 5000); // Hide after 3 seconds
    return () => clearTimeout(timer);
  }, []);

  if (!loading) return null;

  return (
    <motion.div
      className="page-loader"
      initial={{ y: -0 }}
      animate={{ y: "100%" }}
      transition={{ duration: 5, ease: "easeInOut" }}
    >
      <img src="/images/dr-check-loader-01.png" alt="Loading" className="loader-image" />
    </motion.div>
  );
};

export default PageLoader;
